import React, { Component } from 'react';

import ReactPaginate from 'react-paginate';

import { Link } from 'react-router-dom';

import '../Pagination.css';

import '../common/MdPage.css';

import * as constantClass from '../fileWithConstants';

import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';

import { displayDate } from '../../services/dates/dateService';

import * as inscripcionesService from '../../services/inscripciones/inscripcionesService';

import { classifyInscripcionesError, formatInscripcionCursadaAlumnoResultado } from '../../services/inscripciones/inscripcionesDto';

import { ConfirmDialog } from '../common/ConfirmDialog';

import {

  MdRowActions,

  MdTableActionsCell,

  MdTableCell,

} from '../common/MdRowActions';

import { PlusIcon, SearchIcon } from '../common/mdPageIcons';



function getEstadoInscripcion(estado) {

  if (estado === 'A') return 'Activa';

  if (estado === 'P') return 'Pendiente';

  if (estado === 'G') return 'Acta Generada';

  return 'Lista';

}



export class MDInscripcionCursadaAlumno extends Component {

  static displayName = MDInscripcionCursadaAlumno.name;



  constructor(props) {

    super(props);

    this.state = {

      loading: true,

      searchInput: '',

      perPage: 10,

      paginationData: [],

      pageCount: 0,

      forcePage: 0,

      showErrorMessage: false,

      errorMessage: '',

      successMessage: '',

      deletingId: null,

      pendingDelete: null,

    };

    this.grid = createPagedGridController({

      fetchPage: (query) => inscripcionesService.listInscripcionesCursadaPorAlumno(undefined, query),

      defaultPageSize: 10,

      onChange: (gridState) => this.applyGridState(gridState),

    });

    this.searchInputRef = React.createRef();

  }



  applyGridState(gridState) {

    this.setState({

      paginationData: gridState.items,

      pageCount: gridState.pageCount,

      searchInput: gridState.search,

      perPage: gridState.pageSize,

      loading: gridState.loading,

      forcePage: gridState.forcePage,

    });

  }



  async componentDidMount() {

    const canAccess = await constantClass.canAccess('InscribirCursada');

    if (canAccess) {

      this.populateData();

    }

  }



  handlePageClick = (e) => {

    this.grid.handlePageClick(e).catch((error) => this.handleInscripcionesError(error));

  };



  handleSearchInputChange = (e) => {

    const searchInput = e.target.value;

    const cleared = searchInput.trim() === '';

    this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });

    if (cleared && this.grid.getState().search.trim() !== '') {

      this.grid.clearSearchIfNeeded(this.grid.getState().search).catch((error) => this.handleInscripcionesError(error));

    }

  };



  handleSearchSubmit = (e) => {

    e.preventDefault();

    const search = (this.searchInputRef.current

      ? this.searchInputRef.current.value

      : this.state.searchInput).trim();

    this.setState({ searchInput: search });

    this.grid.submitSearch(search).catch((error) => this.handleInscripcionesError(error));

  };



  handleRemoveItem = (periodo) => {

    if (this.state.deletingId) {

      return;

    }

    this.setState({

      pendingDelete: {

        id: periodo.inscripcionCursadaCod,

        materia: periodo.materia,

      },

    });

  };



  handleCancelDelete = () => {

    if (this.state.deletingId) {

      return;

    }

    this.setState({ pendingDelete: null });

  };



  handleConfirmDelete = () => {

    const { pendingDelete } = this.state;

    if (!pendingDelete || this.state.deletingId) {

      return;

    }

    this.deleteItem(pendingDelete.id);

  };



  buildRowActions(periodo) {

    const id = periodo.inscripcionCursadaCod;

    const estado = periodo.inscripcionCursadaEstado;

    const actions = [];



    if (estado === 'P' || estado === 'A') {

      actions.push({

        key: 'edit',

        label: 'Modificar',

        variant: 'primary',

        icon: 'pencil',

        to: '/update-ica/' + id + '/0',

      });

      actions.push({

        key: 'delete',

        label: this.state.deletingId === id ? 'Eliminando...' : 'Borrar',

        variant: 'danger',

        icon: 'trash',

        onClick: () => this.handleRemoveItem(periodo),

        disabled: this.state.loading || this.state.deletingId === id,

      });

    }



    actions.push({

      key: 'detail',

      label: 'Detalles',

      variant: 'outline',

      icon: 'info',

      to: '/update-ica/' + id + '/1',

    });



    return actions;

  }



  renderTable(periodos) {

    return (

      <div className="md-page__table-card">

        <table className="md-page__table md-page__table--actions-fixed" aria-labelledby="md-ica-title">
          <thead>
            <tr>
              <th scope="col">Materia</th>

              <th scope="col">Fecha de Inscripción</th>

              <th scope="col">Estado de Inscripción</th>

              <th scope="col">Resultado</th>

              <th scope="col" className="md-page__table__actions-header" aria-label="Acciones" />

            </tr>

          </thead>

          <tbody>

            {periodos.map((periodo) => (

              <tr key={periodo.inscripcionCursadaCod}>
                <MdTableCell>{periodo.materia}</MdTableCell>

                <MdTableCell>{displayDate(periodo.inscripcionCursadaFechaHora)}</MdTableCell>

                <MdTableCell>{getEstadoInscripcion(periodo.inscripcionCursadaEstado)}</MdTableCell>

                <MdTableCell>{formatInscripcionCursadaAlumnoResultado(periodo.resultado)}</MdTableCell>

                <MdTableActionsCell>

                  <MdRowActions items={this.buildRowActions(periodo)} />

                </MdTableActionsCell>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    );

  }



  render() {

    const isBusy = this.state.loading;

    const listLoading = this.state.loading && !this.state.deletingId;

    const { pendingDelete } = this.state;



    const contents = listLoading

      ? <p className="md-page__loading"><em>Cargando datos...</em></p>

      : this.renderTable(this.state.paginationData);



    return (

      <div className="md-page md-ica">

        <div className="md-page__header">

          <h1 id="md-ica-title" className="md-page__title">Manejar Datos de Inscripciones a Cursadas</h1>

        </div>



        {!this.state.showErrorMessage ? (

          <div className="md-page__toolbar">

            <Link className="md-page__action-link" to="/add-ica">

              <PlusIcon />

              Nueva Inscripción a Cursada

            </Link>

          </div>

        ) : null}



        <div className="md-page__feedback" aria-live="polite" role="status">

          {this.state.showErrorMessage ? (

            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>

          ) : null}

          {this.state.successMessage ? (

            <div className="md-page__success">{this.state.successMessage}</div>

          ) : null}

        </div>



        {!this.state.showErrorMessage ? (

          <>

            <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>

              <div className="md-page__search-wrap">

                <span className="md-page__search-icon">

                  <SearchIcon />

                </span>

                <input

                  ref={this.searchInputRef}

                  className="md-page__search-input"

                  type="text"

                  name="search"

                  autoComplete="off"

                  disabled={isBusy}

                  placeholder="Ingrese Materia"

                  value={this.state.searchInput}

                  onChange={this.handleSearchInputChange}

                />

              </div>

              <button type="submit" className="md-page__search-btn" disabled={isBusy}>

                Buscar

              </button>

            </form>



            {contents}



            {!listLoading && this.state.pageCount > 1 ? (

              <div className="md-page__pagination">

                <ReactPaginate

                  previousLabel="Anterior"

                  nextLabel="Siguiente"

                  breakLabel="..."

                  breakClassName="break-me"

                  pageCount={this.state.pageCount}

                  marginPagesDisplayed={2}

                  pageRangeDisplayed={5}

                  onPageChange={this.handlePageClick}

                  forcePage={this.state.forcePage}

                  containerClassName="pagination"

                  subContainerClassName="pages pagination"

                  activeClassName="active"

                />

              </div>

            ) : null}

          </>

        ) : null}



        <ConfirmDialog

          open={Boolean(pendingDelete)}

          title="Darse de baja"

          message="¿Desea darse de baja de la materia seleccionada?"

          detail={pendingDelete ? pendingDelete.materia : ''}

          confirmLabel="Confirmar baja"

          cancelLabel="Cancelar"

          variant="danger"

          loading={Boolean(this.state.deletingId)}

          onConfirm={this.handleConfirmDelete}

          onCancel={this.handleCancelDelete}

        />

      </div>

    );

  }



  handleInscripcionesError(error) {

    const outcome = classifyInscripcionesError(error);

    if (outcome.type === 'timeout') {

      constantClass.RedirectToLogin();

      return;

    }

    this.setState({

      showErrorMessage: true,

      errorMessage: outcome.message,

      loading: false,

    });

  }



  async populateData() {

    try {

      await this.grid.load();

    } catch (error) {

      this.handleInscripcionesError(error);

    }

  }



  async deleteItem(id) {

    this.setState({ deletingId: id, showErrorMessage: false, errorMessage: '' });

    try {

      await inscripcionesService.deleteInscripcionCursada(id);

      this.setState({ successMessage: 'La baja de la inscripción se registró correctamente.', pendingDelete: null });

      await this.grid.reloadAfterDelete(this.state.paginationData.length);

    } catch (error) {

      this.handleInscripcionesError(error);

    } finally {

      this.setState({ deletingId: null });

    }

  }

}

